import { Routes, Route, Outlet } from 'react-router-dom';
import Navbar from './components/layout/Navbar.tsx';
import Footer from './components/layout/Footer.tsx';
import AdminSidebar from './components/layout/AdminSidebar.tsx';
import ProtectedRoute from './components/layout/ProtectedRoute.tsx';
import SenpaiChatbot from './components/SenpaiChatbot.tsx';

// Public
import Landing from './pages/Landing.tsx';
import Login from './pages/Login.tsx';
import Register from './pages/Register.tsx';

// Store
import Store from './pages/store/Store.tsx';
import ProductDetail from './pages/store/ProductDetail.tsx';
import Cart from './pages/store/Cart.tsx';
import Checkout from './pages/store/Checkout.tsx';

// Customer
import Orders from './pages/customer/Orders.tsx';
import OrderDetail from './pages/customer/OrderDetail.tsx';
import Support from './pages/customer/Support.tsx';
import NewTicket from './pages/customer/NewTicket.tsx';
import TicketDetail from './pages/customer/TicketDetail.tsx';
import BillingShipping from './pages/customer/BillingShipping.tsx';

// Customer
import ChangePassword from './pages/ChangePassword.tsx';

// Admin
import Dashboard from './pages/admin/Dashboard.tsx';
import ProductManager from './pages/admin/ProductManager.tsx';
import ProductForm from './pages/admin/ProductForm.tsx';
import OrderManager from './pages/admin/OrderManager.tsx';
import AdminOrderDetail from './pages/admin/AdminOrderDetail.tsx';
import TicketManager from './pages/admin/TicketManager.tsx';
import AdminTicketDetail from './pages/admin/AdminTicketDetail.tsx';
import InviteManager from './pages/admin/InviteManager.tsx';
import UserManager from './pages/admin/UserManager.tsx';
import EnrollUser from './pages/admin/EnrollUser.tsx';
import DeveloperConsole from './pages/admin/DeveloperConsole.tsx';

// ─── Layouts ─────────────────────────────────────────────────────────────────

function PublicLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-gray-50/50">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <SenpaiChatbot />
    </div>
  );
}

function AdminLayout() {
  return (
    <div className="min-h-screen flex bg-gray-50/50">
      <AdminSidebar />
      <div className="flex-1 min-w-0">
        <div className="p-6 lg:p-8">
          <Outlet />
        </div>
      </div>
    </div>
  );
}

// ─── App ──────────────────────────────────────────────────────────────────────

export default function App() {
  return (
    <Routes>
      {/* Public + Store layout */}
      <Route element={<PublicLayout />}>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />

        {/* Store (auth required) */}
        <Route path="/store" element={<ProtectedRoute><Store /></ProtectedRoute>} />
        <Route path="/store/:id" element={<ProtectedRoute><ProductDetail /></ProtectedRoute>} />
        <Route path="/cart" element={<ProtectedRoute><Cart /></ProtectedRoute>} />
        <Route path="/checkout" element={<ProtectedRoute><Checkout /></ProtectedRoute>} />

        {/* Customer area */}
        <Route path="/orders" element={<ProtectedRoute><Orders /></ProtectedRoute>} />
        <Route path="/orders/:id" element={<ProtectedRoute><OrderDetail /></ProtectedRoute>} />
        <Route path="/support" element={<ProtectedRoute><Support /></ProtectedRoute>} />
        <Route path="/support/new" element={<ProtectedRoute><NewTicket /></ProtectedRoute>} />
        <Route path="/support/:id" element={<ProtectedRoute><TicketDetail /></ProtectedRoute>} />
        <Route path="/change-password" element={<ProtectedRoute allowUnverified><ChangePassword /></ProtectedRoute>} />
        <Route path="/billing" element={<ProtectedRoute allowUnverified><BillingShipping /></ProtectedRoute>} />
      </Route>

      {/* Admin layout */}
      <Route
        path="/admin"
        element={
          <ProtectedRoute adminOnly>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="products" element={<ProductManager />} />
        <Route path="products/:id" element={<ProductForm />} />
        <Route path="orders" element={<OrderManager />} />
        <Route path="orders/:id" element={<AdminOrderDetail />} />
        <Route path="tickets" element={<TicketManager />} />
        <Route path="tickets/:id" element={<AdminTicketDetail />} />
        <Route path="invites" element={<InviteManager />} />
        <Route path="users" element={<UserManager />} />
        <Route path="enrollment" element={<EnrollUser />} />
        <Route path="developer" element={<DeveloperConsole />} />
      </Route>
    </Routes>
  );
}
